import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck, Zap } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTASection() {
  return <section id="comprar" className="w-full bg-[#1A1A1A] text-white py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden scroll-mt-4" data-id="element-51">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 w-[600px] h-[600px] bg-[#0B6B3A] opacity-25 rounded-full blur-[120px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none" data-id="element-52"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-53">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-54">
          <h2 className="text-4xl sm:text-5xl font-bold mb-6" data-id="element-55">
            Empieza hoy mismo
          </h2>

          <p className="text-lg sm:text-xl text-gray-400 mb-10 max-w-2xl mx-auto" data-id="element-56">
            Te llevas un recurso que puedes usar hoy mismo en tu próximo chat.
          </p>

          {/* Prominent Pricing Card */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.15
        }} className="bg-gradient-to-b from-white/10 to-white/5 backdrop-blur-sm border-2 border-[#0B6B3A]/50 rounded-3xl p-8 sm:p-10 mb-10 max-w-lg mx-auto relative" data-id="element-57">
            {/* Discount Badge */}
            <div className="absolute -top-4 left-1/2 -translate-x-1/2" data-id="element-58">
              <span className="inline-flex items-center gap-1.5 bg-[#0B6B3A] text-white text-sm font-bold px-5 py-2 rounded-full shadow-lg shadow-[#0B6B3A]/30" data-id="element-59">
                <Zap className="w-4 h-4" data-id="element-60" />
                68% DE DESCUENTO
              </span>
            </div>

            {/* Price Display */}
            <div className="mt-4 mb-6" data-id="element-61">
              <div className="flex items-center justify-center gap-3 mb-2" data-id="element-62">
                <span className="text-gray-500 line-through text-2xl sm:text-3xl font-medium" data-id="element-63">
                  $19.99
                </span>
                <ArrowRight className="w-5 h-5 text-gray-500" data-id="element-64" />
                <span className="text-[#DCF8C6] text-5xl sm:text-7xl font-black tracking-tight" data-id="element-65">
                  $6.39
                </span>
              </div>
              <p className="text-gray-400 text-sm mt-2" data-id="element-66">
                Precio por tiempo limitado
              </p>
            </div>

            {/* Divider */}
            <div className="border-t border-white/10 my-6" data-id="element-67"></div>

            {/* What's included mini-list */}
            <ul className="text-left space-y-3 mb-8 max-w-xs mx-auto" data-id="element-68">
              {['El Mapa 5R completo', '25 respuestas listas para copiar', 'Árbol de objeciones', '7 mensajes de follow-up'].map((item, i) => <li key={i} className="flex items-center gap-2 text-gray-300 text-sm" data-id="element-69">
                  <span className="w-5 h-5 rounded-full bg-[#0B6B3A]/30 flex items-center justify-center flex-shrink-0" data-id="element-70">
                    <span className="text-[#DCF8C6] text-xs" data-id="element-71">✓</span>
                  </span>
                  {item}
                </li>)}
            </ul>

            {/* CTA Button */}
            <a href="https://www.nachogerberg.com/cart/42518384443463:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="inline-flex items-center justify-center gap-2 bg-[#0B6B3A] hover:bg-[#095c32] text-white text-xl font-bold py-5 px-10 rounded-xl shadow-[0_0_30px_rgba(11,107,58,0.4)] hover:shadow-[0_0_50px_rgba(11,107,58,0.6)] transition-all transform hover:-translate-y-1 w-full" data-id="element-72">
              Quiero el sistema → $6.39
            </a>

            <div className="flex items-center justify-center gap-2 text-sm text-gray-400 mt-4" data-id="element-73">
              <ShieldCheck className="w-4 h-4" data-id="element-74" />
              <span data-id="element-75">Pago seguro · Entrega inmediata al correo</span>
            </div>
          </motion.div>

          {/* Emotional Close */}
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 max-w-2xl mx-auto" data-id="element-76">
            <p className="text-lg text-gray-200 italic" data-id="element-77">
              "Porque el próximo{' '}
              <span className="text-white font-bold" data-id="element-78">'¿precio?'</span> va a
              llegar igual. <br data-id="element-79" />
              La diferencia es si vas a responder con nervios… o con un
              sistema."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}